export default __webpack_public_path__ + "static/media/Pear@2x.7b33a1d3.png";